import {
  CouponValidationResource,
  couponValidationResourceSchema,
} from "@client/resources/CouponValidationResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { object } from "yup";

export type PostValidateSubscriptionCouponResponse =
  ApiResponse<CouponValidationResource>;

export interface PostValidateSubscriptionCouponRequest {
  code: string;
}

const postValidateSubscriptionCouponResponseSchema = object({
  data: couponValidationResourceSchema.defined(),
});

export const postValidateSubscriptionCoupon = async (
  payload: PostValidateSubscriptionCouponRequest,
): Promise<PostValidateSubscriptionCouponResponse> => {
  const response = await fetchData(
    "/dietitian/coupons/validate",
    APIMethods.POST,
    payload,
  );

  return await postValidateSubscriptionCouponResponseSchema
    .validate(response)
    .catch(logFetchValidateError("/dietitian/coupons/validate"));
};
